import { ReactNode } from "react";
import { Typography, Box, Modal } from "@material-ui/core";
import successIcon from "assets/icn-green-check.svg";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./SuccessAlert.module.css";

export interface SucessAlertProps {
  title: string | ReactNode;
  text: string | ReactNode;
  isOpen: boolean;
}

const useStyles = makeStyles(() => ({
  paper: { maxWidth: "516px", width: "90%" },
}));

const SucessAlert = ({ title, text, isOpen }: SucessAlertProps) => {
  const classes = useStyles();

  return (
    <Modal open={isOpen} classes={{ paper: classes.paper }}>
      <div className={styles.container}>
        <div className={styles.content}>
          <img className={styles.icon} src={successIcon} alt="" />
          <Box mt={2}>
            <Typography align="center" variant="h3" className={styles.titleText}>
              {title}
            </Typography>
          </Box>
          <Box mt={2}>
            <Typography align="center" variant="body1" className={styles.descriptionText}>{text}</Typography>
          </Box>
        </div>
      </div>
    </Modal>
  );
};

export default SucessAlert;
